export const signIn = (credentials) => {
    return (dispatch, _getState, getFirebase) => {
        const firebase = getFirebase();

        firebase.login(credentials)
            .then(() => {
                dispatch({ type: 'SIGNIN_SUCCESS' });
            }).catch((err) => {
                dispatch({ type: 'SIGNIN_ERROR', err });
            });
    }
}

export const signOut = () => {
    return (dispatch, _getState, getFirebase) => {
        const firebase = getFirebase();

        firebase.logout().then(() => {
            dispatch({ type: 'SIGNOUT_SUCCESS' })
        });
    }
}

export const signInPhone = (phoneNumber, appVerifier) => {
    return (dispatch, _getState, getFirebase) => {
    const firebase = getFirebase();
    firebase.auth().signInWithPhoneNumber(phoneNumber, appVerifier)
        .then((confirmationResult) => {
            // SMS sent. Prompt user to type the code from the message, then sign the
            // user in with confirmationResult.confirm(code).

            dispatch({ type: 'OTP_SUCCESS', confirmationResult });
        }).catch((err) => {
            // Error; SMS not sent

            dispatch({ type: 'OTP_ERROR', err });
        });
    }
}

export const signInOTP = (code, confirmationResult) => {
    return (dispatch, _getState) => {
    confirmationResult.confirm(code).then((result) => {
        // User signed in successfully.
        const user = result.user;
        // TODO: Create user if not already existing
        dispatch({ type: 'SIGNIN_SUCCESS' });
    }).catch((err) => {
        // User couldn't sign in (bad verification code?)
        dispatch({ type: 'SIGNIN_ERROR', err });
    });
}
}

export const signUpEmail = (newUser) => {
    return (dispatch, _getState, { getFirebase, getFirestore }) => {
        const firebase = getFirebase();

        firebase.auth().createUserWithEmailAndPassword(
            newUser.email,
            newUser.password
        ).then(() => {
            dispatch({ type: 'SIGNUP_SUCCESS' });
            //TODO: Create User
        }).catch((err) => {
            dispatch({ type: 'SIGNUP_ERROR', err });
        });
    }
}

export const authReducer = (state = {
    authError: null,
    otp_sent: false,
    otp_confirmed: false
}, action) => {

    switch (action.type) {
        case 'OTP_SUCCESS':
            console.log('otp success');
            return {
                ...state,
                otp_sent: true,
                otp_confirmed: false,
                authError: null,
                confirmationResult: action.confirmationResult
            }
            case 'OTP_ERROR':
                console.log('otp error');
                return {
                    ...state,
                    otp_sent: false,
                    otp_confirmed: false,
                    authError:  action.err.message,
                    confirmationResult: null
                }
        case 'SIGNIN_ERROR':
            console.log('login error', action.err.message);
            return {
                ...state,
                otp_sent: false,
                otp_confirmed: true,
                authError: action.err.message,
                confirmationResult: null
            }
        case 'SIGNIN_SUCCESS':
            console.log('login success');
            return {
                ...state,
                otp_sent: false,
                otp_confirmed: true,
                authError: null,
                confirmationResult: null
            }
        case 'SIGNOUT_SUCCESS':
            console.log('signout success');
            return {
                ...state,
                otp_sent: false,
                otp_confirmed: false,
                authError: null,
                confirmationResult: null
            };

        case 'SIGNUP_SUCCESS':
            console.log('signup success')
            return {
                ...state,
                authError: null
            };

        case 'SIGNUP_ERROR':
            console.log('signup error', action.err.message)
            return {
                ...state,
                authError: action.err.message
            }

        default:
            return state
    }
}